import { api } from './api'

export interface SessionDetails {
  title?: string
  _id: {
    timestamp: number
    creationTime: string
  }
  sessionid: number
  'show-capacity'?: boolean | null
  'discussion-tab-enabled'?: boolean
  'discussion-facilitator-only'?: boolean
  'discussion-rules'?: string | null
  'discussion-notifications-enabled'?: boolean
  'require-shipping-address'?: boolean
  basic: {
    event_id: number
    fee: number
    limit: number
    regStart: string
    regEnd: string
    contractAmount: number | null
    fee_early: number | null
    regEarly: string | null
    facilitator_id: number
    contactperson_id: number
    eval_id: number
    noEvalOnline: boolean
    noCatalog: boolean
    notOnline: boolean
    webcomments: string | null
    internalComments: string | null
    confirmationComments: string | null
    subTitle: string | null
    breakoutsession_id: number
    breakoutDisplay: string
    breakoutCode: string
    breakoutSort: number
    breakoutEnabled: boolean
    approved: boolean
    numOnWaitingList: number
    numRegistered: number
    active: boolean
    organization_id: number | null
    Online_Type_ID: number
    subscription_length: string
    subscription_length_id: number
    noWaitinglist: boolean
    allowPO: boolean
    instructors: string
    PrerequisiteSessionID: number | null
    NextSessionID: number | null
    dimensions: any | null
    SPPIs: any | null
    standards: any | null
    LMSTypeID: number
    LengthOfCourse: string | null
    COVID_Accommodations: string
  }
  credits: Array<{
    creditID: number
    creditDisplay: string
    creditEnabled: boolean
    creditSort: number
    creditCode: string
    amount: number
  }>
  instructors: Array<{
    sid: string
  }>
  exclusive_items: any[]
  exclusive_sites: any[]
  group_fees: any[]
  schedule: Array<{
    startDate: string
    endDate: string
    obj_id?: number
    objId?: number
    location_id: number
    locationName?: string
    locationMode?: string | null
    roomName?: string
    locationAddress?: {
      street1: string
      street2: string | null
      city: string
      state: string
      zip: string
      phone: string
      email: string
    } | null
  }>
  promo_codes: any[]
  discounts: any[]
  /** Group discount tiers normalized by the session API, ordered by minParticipants */
  group_discounts?: Array<{ minParticipants: number; fee: number; code?: string; description?: string }>
  course_url?: string | null
}

export const sessionDetailsService = {
  // Tenant is injected by the axios interceptor into /session/* paths
  getSessionDetails: (sessionId: number, signal?: AbortSignal): Promise<SessionDetails> => {
    return api.get(`/session/details/${sessionId}`, { signal, skipAuthRedirect: true })
  }
}
